module.exports = __webpack_public_path__ + "img/binghai.9dbe82bb.jpg";